<template>
  <el-form ref="authGroupForm" :model="data" :rules="rules" label-width="100px">
    <el-form-item label="父级" prop="parentid">
      <el-cascader
        v-model="data.parentid"
        :options="optionData"
        :props="{value: 'id', label: 'title', checkStrictly: true}"
      />
    </el-form-item>
    <el-form-item label="名称" prop="title">
      <el-input v-model.trim="data.title" placeholder="请填写分组名称" />
    </el-form-item>
    <el-form-item label="描述" prop="description">
      <el-input
        v-model.trim="data.description"
        type="textarea"
        rows="6"
        placeholder="请填写分组描述"
      />
    </el-form-item>
    <el-form-item label="排序" prop="sort">
      <el-input v-model.trim="data.listorder" placeholder="请填写排序" />
    </el-form-item>
    <el-form-item label="类型" prop="sort">
      <el-select v-model="data.type" class="add_name" placeholder="请选择类型">
          <el-option
            v-for="items in typeoption"
            :key="items.id"
            :label="items.title"
            :value="items.id"
          />
        </el-select>
    </el-form-item>
    <el-form-item label="状态" prop="status">
      <el-radio-group v-model="data.status">
        <el-radio :label="1">启用</el-radio>
        <el-radio :label="0">禁用</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submit">提交</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {
  getGroupDetail,
  groupChildrenList,
  updateGroup
} from '@/api/authGroup'

export default {
  name: 'AuthGroupEdit',
  components: { },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      data: {
        parentid: '',
        title: '',
        description: '',
        listorder: 100,
        status: 1
      },
      id: null,
      optionData: [{
        id: 0,
        title: '顶级分组'
      }], // 分组筛选列表
      typeoption: [{
        id: 1,
        title: '内部'
      },{
        id: 2,
        title: '外部'
      }],
      rules: {
        parentid: [
          { required: true, message: '父级分组不能为空', trigger: 'change' }
        ],
        title: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
        listorder: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    item: {
      handler(val, oldVal) {
        if (this.item.dialogVisible === true &&
          this.id !== val.id
        ) {
          this.id = val.id
        }
      },
      deep: true
    }
  },
  created() {
    this.id = this.item.id
    this.data.parentid = this.item.parentid
    this.fetchData()
    this.getGroupChildrenList()
  },
  methods: {
    // 获取分组筛选列表
    getGroupChildrenList() {
      this.optionData = []
      this.optionData = [{
        id: 0,
        title: '顶级分组'
      }]
      groupChildrenList().then(res => {
        this.optionData.push(...res.data.list)
      })
    },
    resetData() {
      this.data = {
        parentid: '',
        title: '',
        description: '',
        listorder: 100,
        status: 1
      }
      this.optionData = [{
        id: 0,
        title: '顶级分组'
      }]
      this.item.dialogVisible = false
    },
    // handleChange(e) {
    //   this.data.parentid = e[e.length - 1]
    // },
    fetchData() {
      getGroupDetail(this.item.id).then(response => {
        this.data = response.data
        // this.data.parentid = response.data.parentid
        // this.parentid = response.data.parentid
      }).catch(err => {
        console.log(err)
      })
    },
    submit() {
      if (typeof this.data.parentid !== 'number') {
        this.data.parentid = this.data.parentid[this.data.parentid.length - 1]
      }
      updateGroup(this.id, {
        parent_id: this.data.parentid,
        title: this.data.title,
        description: this.data.description,
        sort: this.data.listorder,
        status: this.data.status,
        type: this.data.type
      }).then(response => {
        this.$emit('updateList')
        this.resetData()
        this.$message({
          message: '更新分组信息成功',
          type: 'success',
          duration: 5 * 1000
        })
      })
    }
  }
}
</script>
